(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["award-badges"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const awardBadges = document.querySelectorAll('.award-badges');
  
  awardBadges.forEach(function(section) {
    const mobilePadding = section.getAttribute('data-mobile-padding');
    
    if (mobilePadding) {
      section.style.setProperty('--mobile-padding', mobilePadding + 'px');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["value-proposition-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const valuePropBars = document.querySelectorAll('.value-proposition-bar');
  
  valuePropBars.forEach(function(bar) {
    const mobilePaddingTop = bar.getAttribute('data-mobile-padding-top');
    const mobilePaddingBottom = bar.getAttribute('data-mobile-padding-bottom');
    
    if (mobilePaddingTop) {
      bar.style.setProperty('--mobile-padding-top', mobilePaddingTop + 'px');
    }
    if (mobilePaddingBottom) {
      bar.style.setProperty('--mobile-padding-bottom', mobilePaddingBottom + 'px');
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
